import React, { Component } from "react";
import ReactDOM from "react-dom";
import { constants, KeolisSpinner } from './common/commonExport';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getWorkdayAction,
  onCertifyAction,
  editWorkday,
  deleteWorkday,
  addWorkday,
  hideModalAction,
  showModalAction, setDefaultWorkdayAction, toggleWorkdayAction, editAllActivityAction,
  actErrorAction, submitWorkdayAction, resetWorkdayAction, changesInActivityAction,
  tabChangeAction
} from "../actions/index";
import Activities from "./activities";
import CommentsModal from "./comments-modal";
import ActivityModalComp from '../components/activity-modal-ncnp';
import ScrollArea from "react-scrollbar";
import moment from "moment";
import EandDActivies from './e-and-d-activities';

class ActivityModalNCNP extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      defaultWorkday: {},
      toggleState: false,
      key: 1,
      isEdit: false
    };
  }

  oncloseErrPop() {
    if (this.props.activityErr) {
      this.props.onActErr(false, true);  // para1: errpop, para2: acterr
    } else {
      this.props.onActErr(false, false);  // para1: errpop, para2: acterr
    }
  }


  renderCertifyModal(defaultWorkday) { 
    var addingWorkday = false;
    var workdays = this.props.workdays;
    var workday = this.props.workday, count = this.state.count;
    if (defaultWorkday && Object.keys(defaultWorkday).length > 0) {
      workday = Object.assign({}, JSON.parse(JSON.stringify(defaultWorkday)));
    }
    if (workday && Object.keys(workday).length > 0) {
      if (count == 0) {
        var defaultWorkday = JSON.parse(JSON.stringify(workday));
        this.props.setDefaultWorkday(defaultWorkday);
        this.setState({
          count: count + 1
        });
      }

      if (
        this.props.showModal == true &&
        (this.props.modalName == constants.hosModals.Certify_Modal ||
          this.props.modalName == constants.hosModals.Comments_Modal)
      ) {
        return (
          <Activities validWorkday={this.chkWorkdayValidity()} showEditActivityButton={this.showEditActivityButton()}
            defaultWorkday={workday} addingWorkday={addingWorkday} eventKey={this.state.key} isEdit={this.state.isEdit} oncloseErrPop={() => this.oncloseErrPop.bind(this)} />);
      }
    } else {
      return (
        <KeolisSpinner />
      );
    }
  }

  onCancelEmpComments() {
    this.props.onActErr(false, true); // para1: errpop, para2: acterr
    var workday = this.props.workday;
    this.props.onChangesInActivity(false);
  }

  onCancelActivityModal(workdayObj) {
    this.setState({ key: 1, isEdit: false },
      () => this.props.tabChange(this.state.key))
    this.props.resetWorkday(JSON.parse(JSON.stringify(this.props.defaultWorkday)));
    this.renderCertifyModal();
    this.props.onChangesInActivity(false);
    setTimeout(
      function () {
        const scrollContainer = ReactDOM.findDOMNode(
          this.scrollContainer
        );
      });
    document.querySelectorAll('.showDetails input')[0].removeAttribute('disabled');
    document.querySelectorAll('.showDetails')[0].classList.remove("toggleDisabled");
  }

  renderEnDTab() {
    if (this.state.key == 3) {
      return (
        <EandDActivies />
      )
    }
  }

  checkActivityValid(activity) {
    let valid;
    if (activity.dty_act_name === '' || activity.dty_act_start_time === '' || activity.dty_act_end_time === '') {
      valid = false;
    } else {
      valid = true;
    }
    return valid;
  }

  onCertify(workdayId, changesInActivity) {
    let signOffTimeToday = this.props.workday.wdy_hos_11h59value;
    var certifyByAdmin = constants.certifyByAdmin;
    var role = this.props.authDetails.role;
    var error = '', isValid = true;
    var duty_activity = this.props.workday.duty_activity;
    var len = 0, deleted = 0,
      dutyActivityIsPresent = this.props.workday.dutyActivityStatus == 'Y' ? true : false;
    var checkActivity;
    for (var activity in duty_activity) {
      len++;
      checkActivity = this.checkActivityValid(duty_activity[activity]);
      if (duty_activity[activity].isDeleted) {
        deleted++;
      }
      if ((duty_activity[activity].isDeleted !== true) || duty_activity[activity].isNew === true) {
        if (duty_activity[activity].dty_act_name === '' && duty_activity[activity].dty_act_start_time === '' && duty_activity[activity].dty_act_end_time === '') {
          isValid = false;
          error = 'Please enter activity details for newly added activity';
        }
        else if (duty_activity[activity].dty_act_name === 'Select Activity') {
          isValid = false;
          error = 'Please select activity for newly added activity';
        }
        else if (duty_activity[activity].dty_act_start_time === '' && duty_activity[activity].dty_act_end_time === '') {
          error = 'Please enter start time and end time for newly added activity';
          isValid = false;
        }
        else if (duty_activity[activity].dty_act_start_time === '') {
          error = 'Please enter start time for newly added activity';
          isValid = false;
        } else if (duty_activity[activity].dty_act_end_time === '') {
          error = 'Please enter end time for newly added activity';
          isValid = false
        }
      }
    }
    if (len === deleted) {
      var error = "At least 1 activity should be there to certify";
      this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
      return;
    }

    var counter = 0;
    if (this.props.activityErr) {
      for (var activity in duty_activity) {
        if (duty_activity[activity].isErr) {
          counter += 1;
        }
      }
      if (isValid === false) {
        this.props.onActErr(true, true, error); // para1: errpop, para2: acterr
      } else {
         if (signOffTimeToday) {
          this.props.onShowModal("Comments_Modal");
        }
        else if (!changesInActivity) {
          this.props.onCertify(workdayId, this.props.workday, "", changesInActivity, role, certifyByAdmin);
        } else if (changesInActivity && checkActivity) {
          this.props.onShowModal("Comments_Modal");
        } else {
          var error = 'Please enter activity details for newly added activity';
          this.props.onActErr(true, true, error);
        }
      }
    } else {
      if (signOffTimeToday) {
        this.props.onShowModal("Comments_Modal");
      } else if (!changesInActivity) {
        this.props.onCertify(workdayId, this.props.workday, "", changesInActivity, role, certifyByAdmin);
      } else if (changesInActivity && checkActivity) {
        this.props.onShowModal("Comments_Modal");
      } else {
        var error = 'Please enter activity details for newly added activity';
        this.props.onActErr(true, true, error);
      }
    }
  }
  showAlert() {
    var hideActivityModal = confirm("You will lose unsaved data.\nAre you sure you want to proceed?");
    if (hideActivityModal) {
      this.props.hideModal(false, "Certify_Modal");
    }
  }
  onHideModal() {
    this.setState({ isEdit: false })
    var changesInActivity = this.props.changesInActivity;
    if (changesInActivity) {
      this.showAlert();
    } else {
      this.props.hideModal(false, "Certify_Modal");
      this.props.toggleWorkday(false)
    }
    this.props.setDefaultWorkday({});
  }

  onEditAllActivity() {
    this.setState({ isEdit: true })
    let workday = this.props.workday, deleted = 0,
      error = 'At least 1 activity should be there to Edit';
    if (workday.duty_activity) {
      let dutyActivitycount = workday.duty_activity.length;
      for (var activity in workday.duty_activity) {
        if (workday.duty_activity[activity].isDeleted) {
          deleted++;
        }
      }
      if (dutyActivitycount === deleted) {
        this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
      } else {
        this.props.editAllActivity();
        if(document.querySelectorAll('.showDetails input')[0]){
          document.querySelectorAll('.showDetails input')[0].setAttribute('disabled', 'disabled');
          document.querySelectorAll('.showDetails')[0].classList.add("toggleDisabled");
        }        
      }
    } else {
      this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
    }
    this.setState({
      key:2
    })
  }

  showEditActivityButton() {
    let workday = this.props.workday;
    if (workday) {
      if (workday.dutyActivityStatus == "N") {
        return false;
      } else if (workday.duty_activity && workday.duty_activity.length == 0) {
        return false;
      }
    }
    return true;
  }
  checkPrevNonCertifiedWokrday() {
    let workdays = this.props.workdays, nonCertifiedWorkdays = [],
      wdy_date = this.props.workday.wdy_date, j;
    nonCertifiedWorkdays = workdays.filter(function (value, index) { // filtering uncertified workdays
      return ((value.wdy_certify_status == constants.UNCERTIFIED  && value.dutyActivityStatus == 'Y') || value.wdy_certify_status == constants.CLAIM);
    });
    var filtered = nonCertifiedWorkdays.filter(function (value) { // filtering workdays among filtered uncertified workdays
      return moment(wdy_date, constants.dateFormat).isAfter(moment(value.wdy_date, constants.dateFormat))
    });
    return filtered.length > 0 ? false : true;
  }
  toggleButton() {
    let toggleState = this.state.toggleState;
    this.setState({ toggleState: !toggleState }, () => this.props.toggleWorkday(toggleState));
  }
  chkWorkdayValidity() {
    let workday = this.props.workday, validWorkday, showErr;
    if (workday && Object.keys(workday).length > 0) {
      
        validWorkday = this.checkPrevNonCertifiedWokrday();
        showErr = true;

    }
    return {
      'validWorkday': validWorkday,
      'showErr': showErr
    }
  }
  handleTabChange(key) {
    this.setState({ key: key },
      () => this.props.tabChange(this.state.key))
  }

  render() {
    var activityErrMessage = '';
    if (this.props.activityErrPopup) {
      activityErrMessage = this.props.activityErrMessage
    }
    let role = this.props.authDetails.role, validWorkday = false, showErr = false;
    validWorkday = this.chkWorkdayValidity();
    return (
      <ActivityModalComp toggleButton={() => this.toggleButton.bind(this)} toggleState={this.state.toggleState} role={role} showErr={validWorkday.showErr} workday={this.props.workday} showModal={this.props.showModal} onHideModal={() => this.onHideModal.bind(this)}
        modalName={this.props.modalName} modalTitle={constants.MODAL_TITLE} latestRecords={this.props.latestRecords}
        activityErrPopup={this.props.activityErrPopup} showEditActivityButton={this.showEditActivityButton()} defaultWorkday={this.props.defaultWorkday}
        onEditAllActivity={() => this.onEditAllActivity.bind(this)} oncloseErrPop={() => this.oncloseErrPop.bind(this)}
        activityErrMessage={activityErrMessage} renderCertifyModal={this.renderCertifyModal.bind(this)}
        changesInActivity={this.props.changesInActivity} validWorkday={validWorkday.validWorkday}
        onCancelActivityModal={() => this.onCancelActivityModal(this.props.workday)}
        onCertify={() => this.onCertify(this.props.workday.Id, this.props.changesInActivity)}
        handleTabChange={() => this.handleTabChange.bind(this)}
        eventKey={this.state.key} isEdit={this.state.isEdit} renderEnDTab={() => this.renderEnDTab()}
        isLoading={this.props.isLoading} renderErrorMessage={() => this.showErrorMessage()}
        activityErr={this.props.activityErr} certifyError={this.props.certifyError} />
    );
  }
}

function mapStateToProps(state) {
  // coming from store
  return {
    showModal: state.modals.showModal,
    isLoading: state.workday.isLoading,
    modalName: state.modals.modalName,
    changesInActivity: state.modals.changesInActivity,
    workday: state.workday.workday,
    defaultWorkday: state.workday.defaultWorkday,
    workdays: state.workdays.workdays,
    activityErrPopup: state.modals.activityErrPopup,
    activityErr: state.modals.activityErr,
    certifyError: state.modals.certifyError,
    latestRecords: state.modals.latestRecords,
    activityErrMessage: state.modals.activityErrMessage,
    authDetails: state.authState,
    activityModalToggleState: state.activityModalToggleState,
    activityModalkey: state.activityModalkey,
    activityModalIsEdit: state.activityModalIsEdit
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      editAllActivity: editAllActivityAction,
      hideModal: hideModalAction,
      onChangesInActivity: changesInActivityAction,
      onShowModal: showModalAction,
      getWorkday: getWorkdayAction,
      onCertify: onCertifyAction,
      onActErr: actErrorAction,
      onSubmitWorkday: submitWorkdayAction,
      resetWorkday: resetWorkdayAction,
      setDefaultWorkday: setDefaultWorkdayAction,
      toggleWorkday: toggleWorkdayAction,
      tabChange: tabChangeAction
    }, dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(ActivityModalNCNP);
